import { BridgeComponent } from "@hotwired/strada"
import { BridgeElement } from "@hotwired/strada"

export default class extends BridgeComponent {
  static component = "menu"
  static targets = ["title", "item"]

  connect() {
    super.connect()
    window.__depozenOpenActionsMenu = () => {
      this.show({
        preventDefault() {},
        stopImmediatePropagation() {},
        currentTarget: this.element
      })
    }
  }

  disconnect() {
    if (window.__depozenOpenActionsMenu) {
      delete window.__depozenOpenActionsMenu
    }
    super.disconnect()
  }

  show(event) {
    if (!this.enabled) return

    event?.stopImmediatePropagation?.()
    event?.preventDefault?.()

    const title = this.hasTitleTarget ? new BridgeElement(this.titleTarget).title : ""
    const elements = this.actionableItems
    const items = elements
      .map((element, index) => this.menuItem(element, index))
      .filter(Boolean)

    if (items.length === 0) return

    this.send("display", { title, items, source: this.sourceRectForEvent(event) }, message => {
      const selectedIndex = message?.data?.selectedIndex ?? message?.selectedIndex
      this.itemSelected(selectedIndex, elements)
    })
  }

  menuItem(element, index) {
    const bridgeElement = new BridgeElement(element)
    if (bridgeElement.disabled) return null

    return {
      title: bridgeElement.title,
      index
    }
  }

  itemSelected(selectedIndex, elements = this.actionableItems) {
    if (selectedIndex == null) return

    const item = elements[selectedIndex]
    if (!item) return

    const clickable = item.matches("a, button, [data-bs-toggle], [data-bs-target]")
      ? item
      : item.querySelector("a, button, [data-bs-toggle], [data-bs-target]")

    // Un clic simulé sur un lien `_blank` demande une nouvelle fenêtre, que la WebView refuse
    // faute de geste de l'utilisateur (attestation, tableau de bord paiement) : la visite part
    // d'ici, et l'app décide où l'ouvrir.
    if (clickable?.matches('a[target="_blank"][href]')) {
      window.Turbo.visit(clickable.href)
      return
    }

    ;(clickable ?? item).click()
  }

  // Toutes les entrées du menu web, dans l'ordre : celles marquées `item`, mais aussi les
  // `.dropdown-item` des partiels propres au modèle (frise du contrat, invitation du souscripteur,
  // attestation, actions rapides…), que l'app ne proposait pas. Une entrée imbriquée dans une
  // autre (bouton de modale enveloppé dans un `item`) ne compte qu'une fois, et le contenu des
  // modales rendues avec leur bouton n'en est pas.
  get actionableItems() {
    const selector = '[data-bridge--menu-target~="item"], .dropdown-item:not(.disabled)'

    return Array.from(this.element.querySelectorAll(selector)).filter(element => {
      const modal = element.closest(".modal")
      if (modal && this.element.contains(modal)) return false

      const outer = element.parentElement?.closest(selector)
      return !outer || !this.element.contains(outer)
    })
  }

  sourceRectForEvent(event) {
    if (this.enabled) {
      const anchorSize = 44
      return {
        x: window.innerWidth - anchorSize,
        y: 0,
        width: anchorSize,
        height: anchorSize
      }
    }

    const element = event?.currentTarget ?? this.element
    const rect = element.getBoundingClientRect()

    return {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    }
  }
}
